import { useEffect } from "react";
import FormFields from "../components/common/FormFields";
import { FormSection } from "../components/common/FormSection";
import useGet from "../hooks/common/useGet";
import { IFormSection, TError } from "../types/common";
import { API_CONFIGURABLES } from "./apis";
import { getResultOptions } from "./helpers";

export function createForm(
  sections: IFormSection[],
  form: any,
  updateFormValues: any,
  updateFormValue: any,
  onChange?: any,
  error?: any,
  options?: any,
  setError?: any,
): JSX.Element {
  const alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];

  return (
    <>
      {sections?.map((section, i) => {
        const { title, fields, visible = true, component, ...props } = section;

        if (!visible) {
          // set all fields in the section to visible false
          try {
            fields.forEach((field) => (field.visible = false));
          } catch (e) {
            console.error(e);
          }
          return null;
        }
        return (
          <div key={i}>
            <FormSection
              section={`Section ${alphabet[i]}`}
              title={title}
              key={i}
              {...props}
            >
              {/* FORM FIELDS */}
              <FormFields
                fields={fields}
                error={error as TError}
                form={form}
                onChange={onChange}
                options={options}
                updateFormValue={updateFormValue}
                updateFormValues={updateFormValues}
                setError={setError}
              />
              {/* CUSTOM COMPONENT */}
              {component}
            </FormSection>
          </div>
        );
      })}
    </>
  );
}
interface IConfig {
  name: string;
  key: string;
  url?: string;
  itemName?: string;
}
export const useGetConfigurableOptions = (config: IConfig[]) => {
  const optionsState: any = {};
  const loaders: any = {};
  const dataRefs: any = {};

  config.forEach(({ key, name }) => {
    const { loadData, data } = useGet();
    loaders[key] = loadData;
    dataRefs[key] = data;
    optionsState[name] = [];
  });

  useEffect(() => {
    config.forEach(({ key, url }) => {
      loaders[key]({
        api: url || API_CONFIGURABLES,
        params: url ? {} : { key },
      });
    });
  }, []);

  config.forEach(({ key, name, itemName }) => {
    optionsState[name] = getResultOptions(dataRefs[key], itemName);
  });

  return optionsState;
};
